export function getJsActionsRunner(Vue, jsActionsApiInstance, processingApi) {
  Vue.$jsActionsRunner = Vue.prototype.$jsActionsRunner = { 
    async callJsActions (id, properties, settings) {
      function showLoading() {
        switch (settings?.loadIndicator) {
          case 'blockingUI':
            processingApi.showModal(settings.loadIndicatorText)
            break
          case 'nonBlockingUI':
            processingApi.show()
            break
          case 'noIndicator':
            break
        }
      }
      let jsActionsResult = undefined
      try {
        showLoading()
        jsActionsResult = jsActionsApiInstance.call(id, properties)
      } catch (e) {
        jsActionsResult = e
      } finally {
          jsActionsResult?.finally?.(() => { 
            processingApi.hideAll()
          })
      }
      return jsActionsResult
    }
  }
}